import 'slick-carousel';
import 'jquery-ui-dist/jquery-ui.min';
import '@fancyapps/fancybox'

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function(item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Change header on scroll
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var headerEl = document.querySelector("header");
    var sentinalEl = document.querySelector(".header-sentinal");

    var handler = function handler(entries) {
        if (!entries[0].isIntersecting) {
            headerEl.classList.add("header--scrolled");
        } else {
            headerEl.classList.remove("header--scrolled");
        }
    };

    var observer = new window.IntersectionObserver(handler);
    observer.observe(sentinalEl);
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

$(".js-trigger-mobile-nav").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("is-active")
    $(".main-nav").fadeToggle();
});

/* ==========================================================================
   Sub Nav
   ========================================================================== */

$(".js-toggle-subnav").click(function (e) {
    e.preventDefault();

    $(".sub-nav").not(this).fadeOut();
    $(".main-nav__link").not(this).removeClass("main-nav__link--sub-nav-active");

    if($(this).hasClass("main-nav__link--sub-nav-active")) {
        $(this).removeClass("main-nav__link--sub-nav-active")
        $(this).parent().find(".sub-nav").fadeOut();
    } else {
        $(this).addClass("main-nav__link--sub-nav-active")
        $(this).parent().find(".sub-nav").fadeIn();
    }
});

$(".js-close-subnav").click(function (e) {
    e.preventDefault();
    $(".main-nav__link").removeClass("main-nav__link--sub-nav-active");
    $(".sub-nav").fadeOut();
});

/* ==========================================================================
   Cookies banner
   ========================================================================== */

$(".js-close-cookies").click(function (e) {
    e.preventDefault();
    $(".cookies-banner").fadeOut();
    $.cookie("_rs_usrCkAccept", true, { expires: 365, path: '/' });
});

/* ==========================================================================
   Category Menu - Prev/Next buttons
   ========================================================================== */

if ($(".category-menu__container").prop('scrollWidth') > $(".category-menu__container").width()) {
    $(".category-menu__nav-button").show();
} else {
    $(".category-menu__nav-button").hide();
}

$('body').on('click', '.js-category-menu-prev', function() {
    console.log("click prev")
    $('.category-menu__container').animate({
        scrollLeft: '-=150'
    });
});

$('body').on('click', '.js-category-menu-next', function() {
    console.log("click next")
    $('.category-menu__container').animate({
        scrollLeft: '+=150'
    });
});

/* ==========================================================================
   Slick Sliders
   ========================================================================== */

$('.js-hero-slider').on('init', function (event, slick) {
    //on hero slider initialized
    setHeroSliderArrowColour();
});

$('.js-hero-slider').slick({
    fade: true,
    dots: true,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-chevron-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-chevron-right"></use></svg></button>',
    appendArrows: $(".js-hero-slider-arrows"),
    appendDots: $(".js-hero-slider-dots"),
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                arrows: false,
                dots: true
            }
        }
    ]
});

$(document).on('click', '.js-hero-slider-arrows', function (e) {
    setHeroSliderArrowColour();
});

function setHeroSliderArrowColour() {
    var colorClass = $('.js-hero-slider .slick-active .js-hero-slide').data('color');
    var colorClassList = 'brand brand-dark brand-secondary brand-secondary-light white';
    $('#slick-prev-icon').removeClass(colorClassList);
    $('#slick-next-icon').removeClass(colorClassList);
    $('#slick-prev-icon').addClass(colorClass);
    $('#slick-next-icon').addClass(colorClass);
}

$('.js-products-slider').slick({
    dots: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        },
        {
            breakpoint: 740,
            settings: "unslick"
        }
    ]
});

$('.js-recipes-slider').slick({
    fade: true,
    dots: true,
    arrows: true,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                arrows: false
            }
        }
    ]
});

$(".js-product-image-slider").slick({
    fade: true,
    dots: true,
    arrows: false,
    appendDots: $(".js-product-image-slider-dots"),
    customPaging : function(slider, i) {
        var sliderNav = $(slider.$slides[i]).find(".product-detail-image__slide").data('slidenav');
        return '<button class="history-slider__nav"><img src='+sliderNav+'></button>';
        console.log(sliderNav);
    }
});

$('.js-related-articles-slider').slick({
    dots: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: false
            }
        },
        {
            breakpoint: 740,
            settings: "unslick"
        }
    ]
});

/* ==========================================================================
   Tabs
   ========================================================================== */

$( ".tabs" ).tabs({
    heightStyle: "auto"
});


/* ==========================================================================
   Accordion
   ========================================================================== */

$( ".accordion" ).accordion({
    collapsible: true,
    active: false,
    heightStyle: "content"
});


/* ==========================================================================
   Our Story - Timeline Animation
   ========================================================================== */

if ($(".timeline-section").length) {
    const container = document.querySelector('.timeline-section');
    const highlight = document.querySelector('.timeline__progress-inner');
    var containerHeight;

    window.onscroll = function() {
        containerHeight = (container.offsetHeight - window.innerHeight);
        let containerPos = container.getBoundingClientRect();
        let diff = containerHeight + containerPos.top;
        let progressPercentage =  diff / containerHeight * 100;
        let height = Math.floor(100 - progressPercentage);
        highlight.style.height = height + "%";
    }
}

if ('IntersectionObserver' in window) {
    const timelineObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("is-active");
            } else {
                entry.target.classList.remove("is-active");
            }
        });
    }, {threshold: 0.5, rootMargin: '0px 0px -20% 0px'});
    const timelineItems = document.querySelectorAll(".timeline__item");

    timelineItems.forEach((item, index) => {
        timelineObserver.observe(item, index);
    });
}

/* ==========================================================================
   Contact form - expand textarea on focus
   ========================================================================== */

$('.js-expand-textarea').focus( function() {
    if($(this).height() < 100) {
        $(this).attr('data-height', $(this).height());
        $(this).animate({ height: 100 }, 'slow');
    }
});
